import { render, staticRenderFns } from "./EducationalVideoModal.vue?vue&type=template&id=3b772d87&scoped=true"
import script from "./EducationalVideoModal.vue?vue&type=script&lang=js"
export * from "./EducationalVideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b772d87",
  null
  
)

export default component.exports